Pegasus.TypographyView = Em.View.extend({
  classNames: ['typo'],
  template: Em.Handlebars.compile('{{view.displayValue}}'),
  attributeBindings: ['style'],
  displayValue: function(){
    return this.get('prioritizedFaceList').split(',')[0].titleize();
  }.property('prioritizedFaceList'),
  classNameBindings: ['isSelected:selected', 'typoClass'],
  typoClass: function(){
    return this.get('displayValue').dasherize();
  }.property('displayValue'),
  isSelected: function(){
    return this.get('controller.selectedFontFace') === this.get('prioritizedFaceList');
  }.property('controller.selectedFontFace', 'prioritizedFaceList'),
  style: function(){
    return 'font-family: ' + this.get('prioritizedFaceList') + ';';
  }.property('prioritizedFaceList'),
  click: function(){
    this.set('controller.selectedFontFace', this.get('prioritizedFaceList'));
  }
});

Pegasus.TypographySelectionView = Em.ContainerView.extend({
  classNames: ['vr-typography'],
  childViews: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o'],
  a: Pegasus.TypographyView.extend({
    prioritizedFaceList: "Open Sans, Calibri, sans-serif"
  }),
  b: Pegasus.TypographyView.extend({
    prioritizedFaceList: "Helvetica, Verdana, Geneva, sans-serif"
  }),
  c: Pegasus.TypographyView.extend({
    prioritizedFaceList: "comic sans ms, cursive"
  }),
  d: Pegasus.TypographyView.extend({
    prioritizedFaceList: "courier, monospace"
  }),
  e: Pegasus.TypographyView.extend({
    prioritizedFaceList: "Raleway, Calibri, sans-serif"
  }),
  f: Pegasus.TypographyView.extend({
    prioritizedFaceList: "Droid Serif, Calibri, sans-serif"
  }),
  g: Pegasus.TypographyView.extend({
    prioritizedFaceList: "Crimson text, Calibri, sans-serif"
  }),
  h: Pegasus.TypographyView.extend({
    prioritizedFaceList: "Lato, Calibri, sans-serif"
  }),
  i: Pegasus.TypographyView.extend({
    prioritizedFaceList: "Arial, Helvetica, sans-serif"
  }),
  j: Pegasus.TypographyView.extend({
    prioritizedFaceList: "Georgia, serif"
  }),
  k: Pegasus.TypographyView.extend({
    prioritizedFaceList: "Lucida Sans Unicode, Lucida Grande, sans-serif",
    displayValue: 'Lucida Sans'
  }),
  l: Pegasus.TypographyView.extend({
    prioritizedFaceList: "Tahoma, Geneva, sans-serif"
  }),
  m: Pegasus.TypographyView.extend({
    prioritizedFaceList: "Times New Roman, Times, serif"
  }),
  n: Pegasus.TypographyView.extend({
    prioritizedFaceList: "Trebuchet MS, Helvetica, sans-serif"
  }),
  o: Pegasus.TypographyView.extend({
    prioritizedFaceList: "Verdana, Geneva, sans-serif"
  })
});
